import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      version="1.1"
      viewBox="0 0 24 24"
      style={{ WebkitPrintColorAdjust: "exact", fill:"none" }}
    >
      <g clipPath="url(#frame-clip-b238f1e1-94c4-11ec-a547-e7091bb4fd45-10cd2230-94c5-11ec-a9cb-6d206c8e158b)">
        <defs>
          <clipPath
            id="frame-clip-b238f1e1-94c4-11ec-a547-e7091bb4fd45-10cd2230-94c5-11ec-a9cb-6d206c8e158b"
            className="frame-clip"
          >
            <path d="M0 0H24V24H0z"></path>
          </clipPath>
        </defs>
        <g>
          <g>
            <path
              fill="none"
              stroke="#434241"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 2a3.429 3.429 0 00-3.429 3.429v9.142a3.429 3.429 0 106.858 0V5.43A3.429 3.429 0 0012 2z"
            ></path>
            <path
              fill="none"
              stroke="#434241"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M20 11.87v2.38c0 4.6-3.582 8.328-8 8.328s-8-3.729-8-8.329v-2.38"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
